<template>
  <div :class="className">
    <p class="d-block font-weight-bolder mb-1 text-uppercase point__title">{{ title }}</p>
    <div v-if="list.length === 0" class="mb-1 mx-2 d-flex align-items-center">
      <i class="material-icons m-1" :style="`color:#c0c1f9;`">lens</i>
      <small>No {{ title }} created</small>
    </div>
    <div v-else class="row justify-content-start">
      <div
        class="d-flex col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 align-items-center"
        v-for="item in list"
        :key="item.id"
      >
        <i class="material-icons m-1" :style="`color:#${item.color};`">lens</i>
        <small>{{ item.name }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    className: [String, Array],
    title: {
      type: String,
      default: 'Title',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.point__title {
  font-size: 14px;
}
.material-icons {
  font-size: 20px;
}
</style>

